import React, {Component, PropTypes} from 'react'
import styles from './input.scss'
import { SelectWrapper } from '../components/shared/select/SelectWrap'
import i18n from 'lib/i18n'
const _ = i18n('')

const TernaryInput = (props) => {
	const options = [
		{value: 'true', label: _('Yes')},
		{value: 'false', label: _('No')},
	]

	const handleBlur = (e) => {
		// New version of react-select does not pass the event to onBlur, but value (hardcodeed by us)
		// Made this way to support both versions of react-select (version 1 and 2)
		// Resolves issue with usage of redux-form and react-select
		if (e && typeof e.preventDefault === 'function') {
			e.preventDefault()
		}
	}

	return (
		<SelectWrapper
			{...props}
			isClearable
			onBlur={handleBlur}
			options={options}
		/>
	)
}

/**
 * Input component
 * @description Be aware that onChange argument could be an event or a string("")
*/
export default class Input extends Component {
	static propTypes = {
		onChange: PropTypes.func.isRequired,
		type: PropTypes.string.isRequired,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		onClear: PropTypes.func,
		hideCancel: PropTypes.bool,
	}

	handleChange = (e) => {
		this.props.onChange(e)
	}
	handleClear = (event) => {
		event.stopPropagation()
		this.props.onChange("") // TODO: pass event to onChange with value = ""
		if (typeof this.props.onClear === 'function') {
			this.props.onClear()
		}
	}

	render() {
		const {type, value, hideCancel, onClear, ...props} = this.props // eslint-disable-line no-unused-vars
		return (
			<div className={styles.inputContainer}>
				{type === 'ternary' ? (
					<TernaryInput
						{...props}
						value={value}
						onChange={this.handleChange}
					/>
				) : (
					<div>
						<input
							{...props}
							type={type}
							value={value}
							onChange={this.handleChange}
						/>
						{Boolean(value) &&
							<button
								type="button"
								onClick={this.handleClear}
								style={{
									opacity: hideCancel ? 0 : 1,
									pointerEvents: hideCancel ? 'none' : 'auto',
								}}
								className={styles.removeInput}
							>
								<span className={styles.cross}>&times;</span>
							</button>
						}
					</div>
				)}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/input.jsx